(function () {
  var storageKey = 'oss:wishlist:v1';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items.filter(function (item) {
        return item && item.handle;
      }) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('oss:wishlist-change', { detail: items }));
  }

  function isSaved(handle) {
    return readWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function updateButtons() {
    var items = readWishlist();
    var handles = items.map(function (item) { return item.handle; });
    document.querySelectorAll('[data-oss-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + (button.getAttribute('data-product-title') || 'product') + (active ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('[data-oss-wishlist-count]').forEach(function (node) {
      node.textContent = String(items.length);
      node.hidden = items.length === 0;
    });
  }

  function showWishlistFeedback(button, active) {
    var message = active ? '\u2713 Saved to Wishlist' : 'Removed from Wishlist';
    button.classList.remove('oss-wishlist-btn--feedback');
    void button.offsetWidth;
    button.classList.add('oss-wishlist-btn--feedback');
    button.setAttribute('data-oss-feedback', active ? 'Saved' : 'Removed');
    window.clearTimeout(button._ossWishlistFeedbackTimer);
    button._ossWishlistFeedbackTimer = window.setTimeout(function () {
      button.classList.remove('oss-wishlist-btn--feedback');
      button.removeAttribute('data-oss-feedback');
    }, 2200);

    var toast = document.querySelector('[data-oss-wishlist-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'oss-wishlist-toast';
      toast.setAttribute('data-oss-wishlist-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.documentElement.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._ossWishlistToastTimer);
    toast._ossWishlistToastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function itemFromButton(button) {
    return {
      id: button.getAttribute('data-product-id') || '',
      handle: button.getAttribute('data-product-handle') || '',
      title: button.getAttribute('data-product-title') || '',
      url: button.getAttribute('data-product-url') || '',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || '',
      variantId: button.getAttribute('data-variant-id') || ''
    };
  }

  function toggleItem(button) {
    var item = itemFromButton(button);
    if (!item.handle) return;
    var items = readWishlist();
    var nextActive = !isSaved(item.handle);
    if (isSaved(item.handle)) {
      items = items.filter(function (saved) {
        return saved.handle !== item.handle;
      });
    } else {
      items.unshift(item);
    }
    writeWishlist(items);
    updateButtons();
    showWishlistFeedback(button, nextActive);
    renderWishlistPage();
  }

  function renderWishlistPage() {
    var page = document.querySelector('[data-oss-wishlist-page]');
    if (!page) return;
    var grid = page.querySelector('[data-oss-wishlist-grid]');
    var empty = page.querySelector('[data-oss-wishlist-empty]');
    var template = page.querySelector('[data-oss-wishlist-template]');
    if (!grid || !empty || !template) return;
    var items = readWishlist();
    grid.innerHTML = '';
    empty.hidden = items.length > 0;
    items.forEach(function (item) {
      var fragment = template.content.cloneNode(true);
      var card = fragment.querySelector('.oss-wishlist-card');
      var remove = fragment.querySelector('[data-oss-wishlist-remove]');
      var image = fragment.querySelector('[data-oss-wishlist-image]');
      var mediaLink = fragment.querySelector('[data-oss-wishlist-url]');
      var titleLink = fragment.querySelector('[data-oss-wishlist-title-link]');
      var price = fragment.querySelector('[data-oss-wishlist-price]');
      var variant = fragment.querySelector('[data-oss-wishlist-variant]');
      var form = fragment.querySelector('[data-oss-wishlist-form]');
      var view = fragment.querySelector('[data-oss-wishlist-view]');

      if (card) card.setAttribute('data-product-handle', item.handle);
      if (remove) remove.setAttribute('data-product-handle', item.handle);
      if (image) {
        image.src = item.image || '';
        image.alt = item.title || '';
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      var productUrl = item.url || (root + 'products/' + item.handle);
      if (productUrl.charAt(0) === '/' && root !== '/' && productUrl.indexOf(root) !== 0) {
        productUrl = root + productUrl.replace(/^\/+/, '');
      }
      [mediaLink, titleLink, view].forEach(function (link) {
        if (!link) return;
        link.href = productUrl;
      });
      if (titleLink) titleLink.textContent = item.title || item.handle;
      if (price) price.textContent = item.price || '';
      if (variant) variant.value = item.variantId || '';
      if (form) {
        form.hidden = false;
        form.setAttribute('data-product-handle', item.handle || '');
        form.setAttribute('data-product-title', item.title || item.handle || 'Product');
        form.setAttribute('data-product-url', productUrl);
      }
      grid.appendChild(fragment);
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-oss-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleItem(toggle);
      return;
    }
    var remove = event.target.closest('[data-oss-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      var handle = remove.getAttribute('data-product-handle');
      writeWishlist(readWishlist().filter(function (item) {
        return item.handle !== handle;
      }));
      updateButtons();
      renderWishlistPage();
    }
  });

  document.addEventListener('oss:wishlist-change', updateButtons);
  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    renderWishlistPage();
  });
  updateButtons();
})();
